// views/newProject/_trialFinishedOwner.js
// !TODO: description

import app from '$$app';
import common from './common';

import viewModes from '../../helpers/viewModes';
import projectsModel from '$$projectModel';
import Store from '../../store/main';

const __ = window.__;
const ID_VIEW_TRIAL_FINISHED_WINDOW = 'trialFinishedPopup';
const ID_VIEW_TRIAL_FINISHED_BODY = 'trialFinishedPopupBody';

const {
  templates: { trialFinished },
  ids: { ID_EVENT_TRIAL_OR_SUBSCRIPTION_COMPLETE },
} = common;

// ?WTF
if (!webix.env.touch && webix.ui.scrollSize) {
  webix.CustomScroll.init();
}

const webixUI = {
  view: 'window',
  id: ID_VIEW_TRIAL_FINISHED_WINDOW,
  css: 'choose-trial owner',
  borderless: true,
  header: false,
  headHeight: 0,
  zIndex: 50, // 10
  modal: false,
  move: false,
  hidden: true,
  unClosable: true,
  padding: 10,
  position(state) {
    const leftSideBarWidth = Store.getters.leftSidebarWidth;

    state.height = document.body.clientHeight + 2;
    state.width = document.body.clientWidth - leftSideBarWidth + 1;
    state.left = leftSideBarWidth;
    state.top = 0;
  },
  body: {
    rows: [{
      width: 600,
      view: 'template',
      id: ID_VIEW_TRIAL_FINISHED_BODY,
      css: 'trial_inner',
      borderless: true,
      scroll: true,
      data: {
        title: __('trial_popup_completed_title'),
        icon: `${GT.cdn}/imgs/over_gantt_imgs/im_trial-period-is-over.png`,
        text: __('trial_popup_completed_text'),
        btn: __('trial_popup_completed_btn'),
        desc: __('trial_popup_completed_desc'),
        userType: 'owner',
      },
      template: trialFinished,
      onClick: {
        'js-upd-trial': function (e) {
          e.preventDefault();

          // app.trigger('paymentPlanInfo:show', {
          //   type: 'default'
          // });
          Store.commit('paymentClient/showPaymentPage', true);
          userExtAnalytics.log('owner_trial_period_over_popup_upgrade_account_click');
        },
        'js-init-lc': function () {
          app.trigger('app:footer:livechat:click');
        },
      },
    }],
  },
  on: {
    onHide: onPopupHide,
    onShow: onPopupShow,
  },
};

const _events = {
  'body:resize': {
    fn: data => {
      $$(ID_VIEW_TRIAL_FINISHED_WINDOW) && $$(ID_VIEW_TRIAL_FINISHED_WINDOW).resize();
    },
  },
  'leftSideBar:changedMode': {
    fn: () => {
      $$(ID_VIEW_TRIAL_FINISHED_WINDOW) && $$(ID_VIEW_TRIAL_FINISHED_WINDOW).resize();
    },
  },
};

function onPopupShow() {
  const allProjects = projectsModel.getAllProjects();

  document.querySelectorAll('.webix_view .webix_disabled').forEach(item => item.style['background-color'] = 'inherit');

  // for bg
  if (!allProjects || allProjects.length === 0) {
    $$(ID_VIEW_TRIAL_FINISHED_WINDOW).getNode().style['background-color'] = '#BFBFBF';
  }

  Object.keys(_events).forEach(event => {
    _events[event].id = app.on(event, _events[event].fn);
  });

  app.trigger('user:overTrialOrSubscription', true);

  $$(ID_VIEW_TRIAL_FINISHED_BODY).getNode().querySelector('.inner_template').classList.add('visible');

  userExtAnalytics.log('owner_trial_period_over_popup_show');
}

function onPopupHide() {
  Object.keys(_events).forEach(event => {
    app.off(_events[event].id);
  });
}

function init() {
  console.info('[_trialFinishedOwner] -> init'); // !DEBUG

  $$(ID_VIEW_TRIAL_FINISHED_WINDOW).show();
}

function cleanup() {
  console.info('_trialFinishedOwner -> cleanup'); // !DEBUG

  $$(ID_VIEW_TRIAL_FINISHED_WINDOW).hide();
}

export { webixUI, init, cleanup };
